export enum CalculationFunctionValuesEnum {
  CF0 = 0,
  CF1 = 1,
  CF2 = 2,
  CF3 = 3,
  CF4 = 4,
  CF5 = 5,
  CF6 = 6,
}

export enum MechanicRewardTypesEnum {
  PRIZE = 'prize',
  MONEY = 'coin',
}

export enum MechanicTypeEnum {
  FIXED = 'fixed',
  PERCENT = 'percent',
  CONDITION = 'condition',
  ORDER = 'order',
}
